/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FocusDayPagedData } from '../../models/focus-day-paged-data';

export interface GetInitiativeFocusDays$Params {
  initiativeId: string;
  PageNumber?: number;
  PageSize?: number;
}

export function getInitiativeFocusDays(http: HttpClient, rootUrl: string, params: GetInitiativeFocusDays$Params, context?: HttpContext): Observable<StrictHttpResponse<FocusDayPagedData>> {
  const rb = new RequestBuilder(rootUrl, getInitiativeFocusDays.PATH, 'get');
  if (params) {
    rb.path('initiativeId', params.initiativeId, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FocusDayPagedData>;
    })
  );
}

getInitiativeFocusDays.PATH = '/initiative/{initiativeId}/focusday';
